// extracted by mini-css-extract-plugin
module.exports = {"Container":"EmptyRemixes_Container__bDNIA","Button":"EmptyRemixes_Button__KXi9H","Robot":"EmptyRemixes_Robot__bb2Wk"};